"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProfileEditor = exports.UserProfileModal = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _userProfile = require("user-profile");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _GooglePlacesField = babelHelpers.interopRequireDefault(require("GooglePlacesField"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp2, _class5, _temp3, _class7, _descriptor9, _descriptor10, _descriptor11, _temp4;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var imageOrientations = {
  1: 'none',
  2: 'none',
  // This is "flipped"
  3: 'rotate(180deg)',
  4: 'none',
  5: 'none',
  6: 'rotate(90deg)',
  7: 'none',
  8: 'rotate(270deg)'
};

function checkImageOrientation(image) {
  return new _promisePolyfill.default(function (resolve) {
    try {
      var fileReader = new FileReader();

      fileReader.onloadend = function () {
        try {
          var scanner = new DataView(fileReader.result),
              idx = 0,
              value = 1,
              littleEndian = false,
              maxBytes = scanner.byteLength;

          if (fileReader.result.length < 2 || scanner.getUint16(idx) != 0xffd8) {
            resolve(value);
          }

          idx += 2;

          while (idx < maxBytes - 2) {
            var uint16 = scanner.getUint16(idx, littleEndian);
            idx += 2;

            switch (uint16) {
              case 0xffe1:
                var ev = scanner.getUint16(idx + 8);

                if (ev == 0x4949) {
                  littleEndian = true;
                }

                var exifLength = scanner.getUint16(idx, littleEndian);
                maxBytes = exifLength - idx;
                idx += 2;
                break;

              case 0x0112:
                value = scanner.getUint16(idx + 6, littleEndian);
                maxBytes = 0;
                break;
            }
          }

          resolve(value);
        } catch (e) {
          resolve(1);
        }
      };

      fileReader.readAsArrayBuffer(image);
    } catch (e) {
      resolve(1);
    }
  });
}

var UserProfileModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(UserProfileModal, _Modal);
  babelHelpers.createClass(UserProfileModal, [{
    key: "getModalContent",
    value: function getModalContent() {
      var _this2 = this;

      return (0, _userProfile.getUserProfile)().then(function (profile) {
        _this2.profile = profile;
        return "<div class='profile-edit-wrapper'></div>";
      });
    }
  }, {
    key: "show",
    // Reuse those styles.
    value: function show() {
      var _babelHelpers$get,
          _this3 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(UserProfileModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        _reactDom.default.render(_react.default.createElement(UserProfileEditor, {
          close: function close() {
            return _this3.hide();
          },
          id: _this3.id,
          firstRun: _this3.asFirstRun
        }), element.querySelector('.profile-edit-wrapper'));

        $(element).on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.profile-edit-wrapper'));
        });
        return element;
      });
    }
  }, {
    key: "icon",
    get: function get() {
      return "\n\t\t\t<span class='img-icon img-icon-user'>\n\t\t\t\t<img src='/t/width=1/height=1/cover/width=30/height=30/matte=none/scale/f".concat(this.profile.photo || this.profile.defaultPhoto, "/user-photo.png' class='img-circle'>\n\t\t\t</span>\n\t\t");
    }
  }, {
    key: "title",
    get: function get() {
      return "My Account";
    }
  }, {
    key: "subTitle",
    get: function get() {
      return '';
    }
  }]);

  function UserProfileModal() {
    var _this;

    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'user-profile-modal';
    var asFirstRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    babelHelpers.classCallCheck(this, UserProfileModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(UserProfileModal).call(this, id));
    _this.removeOnHide = true;
    _this.modalBodyInnerClasses = [];
    _this.classList = _this.classList.concat('survey-modal');
    _this.asFirstRun = asFirstRun;
    return _this;
  }

  return UserProfileModal;
}(_base.default);

exports.UserProfileModal = UserProfileModal;

var UserProfileEditor =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(UserProfileEditor, _Component);

  function UserProfileEditor() {
    var _babelHelpers$getProt;

    var _this4;

    babelHelpers.classCallCheck(this, UserProfileEditor);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(UserProfileEditor)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this4.state = {
      userProfile: null
    };
    return _this4;
  }

  babelHelpers.createClass(UserProfileEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;

      (0, _userProfile.getUserProfile)().then(function (profile) {
        _this5.setState({
          userProfile: profile
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.userProfile ? _react.default.createElement(UserProfileEditorContent, {
        close: this.props.close,
        id: this.props.id,
        firstRun: this.props.firstRun,
        profile: this.state.userProfile
      }) : null;
    }
  }]);
  return UserProfileEditor;
}(_react.Component);

exports.UserProfileEditor = UserProfileEditor;
var UserProfileExtraContent = (_class = (_temp =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(UserProfileExtraContent, _Component2);

  function UserProfileExtraContent() {
    var _babelHelpers$getProt2;

    var _this6;

    babelHelpers.classCallCheck(this, UserProfileExtraContent);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(UserProfileExtraContent)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "profile", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "markValid", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "markInvalid", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "section", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(UserProfileExtraContent, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      var x = this.profile.profileHelpers.slice();
      x = x.filter(function (node) {
        return node.section === _this7.section;
      });
      x.sort(function (left, right) {
        return left.order - right.order;
      });
      return _react.default.createElement("div", null, x.map(function (item, index) {
        try {
          var Item = require("components/UserProfile/profile.".concat(item.id)).default;

          return _react.default.createElement(Item, _extends({
            key: index
          }, item, {
            profile: _this7.profile,
            markValid: _this7.markValid,
            markInvalid: _this7.markInvalid
          }));
        } catch (e) {
          console.log(e);
          return null;
        }
      }));
    }
  }]);
  return UserProfileExtraContent;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "markValid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "markInvalid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "section", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var UserProfileMoreExtraContent = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(UserProfileMoreExtraContent, _Component3);

  function UserProfileMoreExtraContent() {
    var _babelHelpers$getProt3;

    var _this8;

    babelHelpers.classCallCheck(this, UserProfileMoreExtraContent);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this8 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(UserProfileMoreExtraContent)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this8, "profile", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "markValid", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "markInvalid", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "ignoreSections", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    return _this8;
  }

  babelHelpers.createClass(UserProfileMoreExtraContent, [{
    key: "render",
    value: function render() {
      var _this9 = this;

      var x = this.profile.profileHelpers.slice();
      x = x.filter(function (node) {
        return _this9.ignoreSections.filter(function (v) {
          return v === node.section;
        }).length == 0;
      });
      x.sort(function (left, right) {
        return (left.sectionOrder || 0) - (right.sectionOrder || 0);
      });
      var sections = [];
      x.forEach(function (v) {
        if (sections.indexOf(v.section) == -1) sections.push(v.section);
      });
      return _react.default.createElement("div", null, sections.map(function (section) {
        return _react.default.createElement("div", {
          key: section
        }, false && _react.default.createElement("div", {
          className: "form-section-header"
        }, _react.default.createElement("p", null, section)), _react.default.createElement(UserProfileExtraContent, {
          profile: _this9.profile,
          markValid: _this9.markValid,
          markInvalid: _this9.markInvalid,
          section: section
        }));
      }));
    }
  }]);
  return UserProfileMoreExtraContent;
}(_react.Component), _temp2), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "markValid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "markInvalid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "ignoreSections", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var AutoExpandingTextField = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(AutoExpandingTextField, _Component4);

  function AutoExpandingTextField() {
    var _babelHelpers$getProt4;

    var _this10;

    babelHelpers.classCallCheck(this, AutoExpandingTextField);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this10 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(AutoExpandingTextField)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    _this10.state = {
      focus: false
    };
    return _this10;
  }

  babelHelpers.createClass(AutoExpandingTextField, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value && this.fakeElement && this.commentField) {
        this.updateSize();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSize();
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(node) {
      this.commentField = node;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this11 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.props.value || "";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this11.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")"));
          tgtH = this.fakeElement.offsetHeight;
          console.log(this.commentField.style.height = this.fakeElement.style.boxSizing == 'border-box' ? "calc(".concat(tgtH, "px + 2px)") : "calc(".concat(tgtH, "px - ").concat(cStyle.paddingTop, " - ").concat(cStyle.paddingBottom, " - ").concat(cStyle.borderTopWidth, " - ").concat(cStyle.borderBottomWidth, " + 2px)"));
        } while (w != this.commentField.clientWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        "data-field": id,
        className: _classList.default.join('form-group', this.state.focus && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: id
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("textarea", {
        ref: this.gotCommentField,
        className: "input-lg form-control",
        name: id,
        id: id,
        rows: "3",
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.props.value ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      }), this.props.children || null);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setState({
        focus: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        focus: false
      });
    }
  }]);
  return AutoExpandingTextField;
}(_react.Component), _temp3), (babelHelpers.applyDecoratedDescriptor(_class5.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "setValue"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotCommentField"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotFakeElement"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onFocus", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "onFocus"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onBlur", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "onBlur"), _class5.prototype)), _class5);

var FirstRun =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(FirstRun, _Component5);

  function FirstRun() {
    babelHelpers.classCallCheck(this, FirstRun);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(FirstRun).apply(this, arguments));
  }

  babelHelpers.createClass(FirstRun, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "firstRunHeader"
      }, _react.default.createElement("h3", null, "Tell us more about yourself"), _react.default.createElement("p", null, "Get the most out of Sundance Co//ab and allow others to connect with you."));
    }
  }]);
  return FirstRun;
}(_react.Component);

var UserProfileEditorContent = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(UserProfileEditorContent, _Component6);

  function UserProfileEditorContent() {
    var _babelHelpers$getProt5;

    var _this12;

    babelHelpers.classCallCheck(this, UserProfileEditorContent);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this12 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(UserProfileEditorContent)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this12, "profile", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "firstRun", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "close", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    _this12.state = {
      selectedTab: 'profile',
      profile: _this12.profile,
      username: _this12.profile.username,
      fullName: _this12.profile.fullName,
      nickname: _this12.profile.nickname,
      title: _this12.profile.title,
      location: _this12.profile.location,
      place: _this12.profile.place,
      bio: _this12.profile.bio,
      invalidProfileComponents: [],
      currentPassword: '',
      newPassword: '',
      fileBlob: null,
      blobOrientation: null,
      isSubmitting: false,
      passwordAlert: '',
      profileAlert: '',
      doDisplayNameAsField: false,
      focus: null
    };
    return _this12;
  }

  babelHelpers.createClass(UserProfileEditorContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('userProfileUpdateHandler', this.handleUserProfileUpdate);
    }
  }, {
    key: "markComponentInvalid",
    value: function markComponentInvalid(component) {
      this.setState(function (state) {
        return {
          invalidProfileComponents: state.invalidProfileComponents.filter(function (item) {
            return item != component;
          }).concat(component)
        };
      });
    }
  }, {
    key: "markComponentValid",
    value: function markComponentValid(component) {
      this.setState(function (state) {
        return {
          invalidProfileComponents: state.invalidProfileComponents.filter(function (item) {
            return item != component;
          })
        };
      });
    }
  }, {
    key: "hasAnyInvalid",
    value: function hasAnyInvalid() {
      if (this.state.invalidProfileComponents.length) return true;
      if (!this.state.profile.fixed.username && !this.state.username) return true;
      if (!this.state.profile.fixed.fullName && !this.state.fullName) return true;
      return false;
    }
  }, {
    key: "handleUserProfileUpdate",
    value: function handleUserProfileUpdate(event) {
      if (event.responseCode == 200) {
        (0, _userProfile.userProfileUpdated)();
        /*
        this.setState({
        	profile: event.body,
        	isSubmitting: false,
        	username: event.body.username,
        	fullName: event.body.fullName,
        	nickname: event.body.nickname,
        	profileAlert: ''
        })
        */

        (0, _noty.showNotificationText)('Your profile has been updated.');
        ClientAPI.emptyCache();
        this.close(); // .hide();
      } else {
        this.setState({
          isSubmitting: false,
          profileAlert: event.body.errorMessage
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.fileBlob) {
        var URL = window.URL || window.webkitURL;
        URL.revokeObjectURL(this.state.fileBlob);
      }

      $(document).off('userProfileUpdateHandler', this.handleUserProfileUpdate);
    }
  }, {
    key: "selectProfileUpdateTab",
    value: function selectProfileUpdateTab(event) {
      event.preventDefault();
      this.setState({
        selectedTab: 'profile'
      });
    }
  }, {
    key: "selectPasswordUpdateTab",
    value: function selectPasswordUpdateTab(event) {
      event.preventDefault();
      this.setState({
        selectedTab: 'password'
      });
    }
  }, {
    key: "setField",
    value: function setField(event) {
      this.setState(babelHelpers.defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "setField2",
    value: function setField2(name, value) {
      this.setState(babelHelpers.defineProperty({}, name, value));
    }
  }, {
    key: "setGooglePlace",
    value: function setGooglePlace(place) {
      this.setState({
        place: place,
        location: place.result.formatted_address
      });
    }
  }, {
    key: "handleFileFocus",
    value: function handleFileFocus(event) {
      var tgt = event.target;
      setTimeout(function () {
        if (tgt == document.activeElement) tgt.blur();
      }, 16);
    }
  }, {
    key: "handleFileChange",
    value: function handleFileChange(event) {
      var _this13 = this;

      var URL = window.URL || window.webkitURL;

      if (URL) {
        if (this.state.fileBlob) {
          URL.revokeObjectURL(this.state.fileBlob);
        }

        if (event.target.files.length) {
          var f = event.target.files[0];
          var url = URL.createObjectURL(f);
          this.setState({
            fileBlob: url
          });
          checkImageOrientation(f).then(function (orientation) {
            return _this13.setState({
              blobOrientation: orientation
            });
          });
        } else {
          this.setState({
            fileBlob: null,
            blobOrientation: null
          });
        }
      }
    }
  }, {
    key: "submitPasswordForm",
    value: function submitPasswordForm(event) {
      var _this14 = this;

      event.preventDefault();
      if (this.state.isSubmitting) return;
      if (this.state.invalidProfileComponentCount) return;
      var _this$state = this.state,
          currentPassword = _this$state.currentPassword,
          newPassword = _this$state.newPassword;
      var fData = {
        currentPassword: currentPassword,
        password: newPassword
      };

      if (currentPassword && newPassword && newPassword.length >= 8) {
        this.setState({
          isSubmitting: true
        }, function () {
          (0, _fetch.default)('account/updatePassword', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(fData)
          }).then(function (result) {
            if (result.ok) {
              (0, _noty.showNotificationText)('Your password has been changed.');
              Instance.hide();
            } else {
              result.json().then(function (value) {
                _this14.setState({
                  isSubmitting: false,
                  passwordAlert: value.error
                }, function () {
                  _this14.passwordField.focus();
                });
              });
            }
          });
        });
        return false;
      }

      var msg;

      if (!currentPassword || !newPassword) {
        msg = 'Please specify your current password & a new password.';
      } else if (newPassword.length < 8) {
        msg = 'Please specify a new password of at least 8 characters.';
      }

      this.setState({
        passwordAlert: msg
      }, function () {
        _this14[currentPassword ? 'newPasswordField' : 'passwordField'].focus();
      });
      return false;
    }
  }, {
    key: "gotPasswordField",
    value: function gotPasswordField(node) {
      this.passwordField = node;
    }
  }, {
    key: "gotNewPasswordField",
    value: function gotNewPasswordField(node) {
      this.newPasswordField = node;
    }
  }, {
    key: "setBootstrapPopover",
    value: function setBootstrapPopover(node) {
      if (node) $(node).popover();
    }
  }, {
    key: "submitProfile",
    value: function submitProfile(event) {
      if (this.hasAnyInvalid()) {
        event.preventDefault();
      } else {
        this.setState({
          isSubmitting: true
        });
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      this.setState({
        focus: event.target.name
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      var t = event.target.name;
      this.setState(function (_ref) {
        var focus = _ref.focus;
        return {
          focus: focus == t ? null : focus
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: _classList.default.join('user-profile-editor', this.firstRun && 'first-run')
      }, !this.firstRun && this.state.profile.isEmailAccount ? _react.default.createElement("ul", {
        className: "nav nav-pills nav-small",
        role: "tablist"
      }, _react.default.createElement("li", {
        className: this.state.selectedTab == 'profile' ? 'active' : ''
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.selectProfileUpdateTab
      }, "Profile")), _react.default.createElement("li", {
        className: this.state.selectedTab == 'password' ? 'active' : ''
      }, _react.default.createElement("a", {
        className: "change-password-tab",
        href: "javascript:void(0)",
        onClick: this.selectPasswordUpdateTab
      }, "Password"))) : null, _react.default.createElement("div", {
        className: "tab-content"
      }, _react.default.createElement("div", {
        className: _classList.default.join('tab-pane', this.state.selectedTab == 'profile' ? 'active' : '')
      }, _react.default.createElement("iframe", {
        id: "userProfileUpdateTarget",
        style: {
          position: 'fixed',
          top: '-1000px',
          left: '-1000px',
          width: '100px',
          height: '100px'
        },
        name: "userProfileUpdateTarget"
      }), _react.default.createElement("form", {
        role: "form",
        method: "post",
        action: "userProfile",
        encType: "multipart/form-data",
        target: "userProfileUpdateTarget",
        onSubmit: this.submitProfile
      }, this.state.profileAlert ? _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.profileAlert) : null, _react.default.createElement("input", {
        type: "hidden",
        name: "event",
        value: "userProfileUpdateHandler"
      }), this.firstRun && _react.default.createElement(FirstRun, null), _react.default.createElement("div", {
        className: "photo-selector"
      }, _react.default.createElement("div", {
        id: "profile-file-upload",
        className: "upload-wrapper"
      }, _react.default.createElement("div", {
        style: Object.assign({
          backgroundImage: "url(".concat(this.state.fileBlob || this.state.profile.photo || this.state.profile.defaultPhoto, ")")
        }, this.state.blobOrientation ? {
          transform: imageOrientations[this.state.blobOrientation]
        } : {}),
        className: _classList.default.join('user-photo', this.state.profile.fileBlob || this.state.profile.photo ? '' : 'placeholder')
      }), this.state.profile.fixed.photo ? null : _react.default.createElement("div", {
        className: "file-select-btn",
        style: {
          zIndex: 1
        }
      }), this.state.profile.fixed.photo ? null : _react.default.createElement("div", {
        className: "file-selector-wrap"
      }, _react.default.createElement("input", {
        type: "file",
        className: "file-selector",
        name: "photo",
        id: "photo",
        accept: "image/*",
        onFocus: this.handleFileFocus,
        onChange: this.handleFileChange
      })))), this.firstRun || !this.state.doDisplayNameAsField || this.state.profile.fixed.fullName ? _react.default.createElement("div", {
        className: "form-group name-display"
      }, _react.default.createElement("h2", null, this.state.fullName), this.state.doDisplayNameAsField && _react.default.createElement("input", {
        type: "hidden",
        id: "fullName",
        name: "fullName",
        value: this.state.fullName
      })) : _react.default.createElement("div", {
        className: _classList.default.join('form-group name-display', this.state.focus == 'fullName' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "fullName",
        className: "sr-only"
      }, "Full Name"), _react.default.createElement("input", {
        className: "input-h2 form-control",
        id: "fullName",
        name: "fullName",
        type: "text",
        required: true,
        value: this.state.fullName,
        onChange: this.setField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), _react.default.createElement("div", {
        "data-field": "username",
        className: _classList.default.join('form-group', this.state.focus == 'username' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "username"
      }, "Email"), _react.default.createElement("input", {
        id: "username",
        className: "input-lg form-control",
        name: "username",
        type: "email",
        required: !this.state.profile.fixed.username,
        disabled: this.state.profile.fixed.username,
        value: this.state.username,
        onChange: this.setField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), !this.state.doDisplayNameAsField && _react.default.createElement("div", {
        "data-field": "fullName",
        className: _classList.default.join('form-group', this.state.focus == 'fullName' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "fullName"
      }, "Full Name"), _react.default.createElement("input", {
        id: "fullName",
        className: "input-lg form-control",
        name: "fullName",
        type: "text",
        required: !this.state.profile.fixed.fullName,
        disabled: this.state.profile.fixed.fullName,
        value: this.state.fullName,
        onChange: this.setField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), _react.default.createElement("div", {
        "data-field": "nickname",
        className: _classList.default.join('form-group', this.state.focus == 'nickname' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "nickname"
      }, "Nickname"), _react.default.createElement("input", {
        id: "nickname",
        className: "input-lg form-control",
        name: "nickname",
        type: "text",
        disabled: this.state.profile.fixed.nickname,
        value: this.state.nickname,
        onChange: this.setField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), _react.default.createElement("div", {
        className: "form-group-help"
      }, "Enter a nickname if you prefer to use it instead of your full name on the site.")), _react.default.createElement("div", {
        "data-field": "title",
        className: _classList.default.join('form-group', this.state.focus == 'title' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "title"
      }, "Title"), _react.default.createElement("input", {
        id: "title",
        className: "input-lg form-control",
        name: "title",
        type: "text",
        disabled: this.state.profile.fixed.title,
        value: this.state.title,
        onChange: this.setField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), _react.default.createElement("div", {
        "data-field": "location",
        className: _classList.default.join('form-group', this.state.focus == 'location' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "location"
      }, "Location"), _react.default.createElement(_GooglePlacesField.default, {
        id: "location",
        className: "input-lg form-control",
        dark: true,
        disabled: this.state.profile.fixed.location,
        initialValue: this.state.locatin,
        initialPlace: this.state.place,
        onChange: this.setGooglePlace,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), _react.default.createElement("div", {
        className: "form-group-help"
      }, "Share your general location so that we can connect you with relevant content and events in your area."), _react.default.createElement("input", {
        type: "hidden",
        name: "location",
        value: this.state.location
      }), _react.default.createElement("input", {
        type: "hidden",
        name: "place",
        value: JSON.stringify(this.state.place)
      })), _react.default.createElement(AutoExpandingTextField, {
        id: "bio",
        text: "Bio",
        disabled: this.state.profile.fixed.bio,
        value: this.state.bio,
        setValue: this.setField2
      }, _react.default.createElement("div", {
        className: "form-group-help"
      }, "Tell the community a little bit about yourself and your career goals.")), _react.default.createElement(UserProfileExtraContent, {
        firstRun: this.firstRun,
        profile: this.state.profile,
        markValid: this.markComponentValid,
        markInvalid: this.markComponentInvalid,
        section: "profile"
      }), false && _react.default.createElement("div", {
        className: "form-section-header"
      }, _react.default.createElement("p", null, "Preferences")), _react.default.createElement(UserProfileExtraContent, {
        firstRun: this.firstRun,
        profile: this.state.profile,
        markValid: this.markComponentValid,
        markInvalid: this.markComponentInvalid,
        section: void 0
      }), _react.default.createElement(UserProfileMoreExtraContent, {
        firstRun: this.firstRun,
        profile: this.state.profile,
        markValid: this.markComponentValid,
        markInvalid: this.markComponentInvalid,
        ignoreSections: ["profile", void 0]
      }), _react.default.createElement("div", {
        className: "form-actions"
      }, _react.default.createElement("p", null, _react.default.createElement("button", {
        type: "submit",
        className: _classList.default.join('btn btn-primary', this.state.isSubmitting ? 'spinning' : ''),
        "data-spin": this.state.isSubmitting ? 'true' : void 0,
        disabled: this.hasAnyInvalid()
      }, "Save")), this.firstRun && _react.default.createElement("p", null, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.close
      }, "No thanks, I'll do this later."))))), !this.firstRun && this.state.profile.isEmailAccount ? _react.default.createElement("div", {
        className: _classList.default.join('tab-pane', this.state.selectedTab == 'password' ? 'active' : '')
      }, _react.default.createElement("form", {
        role: "form",
        onSubmit: this.submitPasswordForm
      }, this.state.passwordAlert ? _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.passwordAlert) : null, _react.default.createElement("div", {
        className: _classList.default.join('form-group', this.state.focus == 'currentPassword' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "currentPassword"
      }, "Current password"), _react.default.createElement("input", {
        name: "currentPassword",
        id: "currentPassword",
        className: "form-control input-lg",
        type: "password",
        value: this.state.currentPassword,
        onChange: this.setField,
        ref: this.gotPasswordField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), _react.default.createElement("div", {
        className: _classList.default.join('form-group', this.state.focus == 'newPassword' && 'focus')
      }, _react.default.createElement("label", {
        htmlFor: "newPassword"
      }, "New password"), _react.default.createElement("div", {
        className: "input-group"
      }, _react.default.createElement("input", {
        name: "newPassword",
        id: "newPassword",
        className: "form-control input-lg",
        type: "password",
        value: this.state.newPassword,
        onChange: this.setField,
        ref: this.gotNewPasswordField,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), _react.default.createElement("div", {
        className: "input-group-btn"
      }, _react.default.createElement("a", {
        className: "btn btn-default password-help",
        "data-toggle": "popover",
        ref: this.setBootstrapPopover,
        title: "Password Requirements",
        role: "button",
        "data-html": "true",
        "data-trigger": "click",
        "data-placement": "right auto",
        "data-content": "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div>Password must be at least 8 characters long.</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t",
        tabIndex: -1
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "help"
      }))))), _react.default.createElement("div", {
        className: "form-actions"
      }, _react.default.createElement("p", null, _react.default.createElement("button", {
        type: "submit",
        className: _classList.default.join('btn btn-primary', this.state.isSubmitting ? 'spinning' : ''),
        "data-spin": this.state.isSubmitting ? 'true' : void 0
      }, "Save"))))) : null));
    }
  }]);
  return UserProfileEditorContent;
}(_react.Component), _temp4), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "firstRun", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "close", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "markComponentInvalid", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "markComponentInvalid"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "markComponentValid", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "markComponentValid"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "handleUserProfileUpdate", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "handleUserProfileUpdate"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "selectProfileUpdateTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "selectProfileUpdateTab"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "selectPasswordUpdateTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "selectPasswordUpdateTab"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setField"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setField2", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setField2"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setGooglePlace", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setGooglePlace"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "handleFileFocus", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "handleFileFocus"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "handleFileChange", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "handleFileChange"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "submitPasswordForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "submitPasswordForm"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "gotPasswordField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "gotPasswordField"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "gotNewPasswordField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "gotNewPasswordField"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setBootstrapPopover", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setBootstrapPopover"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "submitProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "submitProfile"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "onFocus", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "onFocus"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "onBlur", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "onBlur"), _class7.prototype)), _class7);
var Instance = new UserProfileModal();
var _default = Instance;
exports.default = _default;